
export const preloadedValues = {
    prPDRecStatus:false,
    prPDDescricao:"",
    prPDTipo:0,
    prPDValor:"",
  };